export default "https://assets.egbcdn.net/assets/packs/_/images/app/ios/ios-ru-1-55beb95970c0a7945160bc54898aa272.png";